export default __webpack_public_path__ + "f569a6af043c7caf94b07bf3576a9ec4.png";